import 'vex-js/dist/css/vex.css';
import VexDialog from 'vex-dialog';
import Vex from 'vex-js';
import Bean from 'bean';

import BaseBaseService from '../abstracts/BaseService';

export default class ModalService extends BaseBaseService {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.show]: this.showModal,
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.close]: this.closeModals
    };
  }

  get DEFAULT_OPTS() {
    return {
      content: '',
      unsafeContent: '',
      showCloseButton: true,
      escapeButtonCloses: true,
      overlayClosesOnClick: true,
      appendLocation: 'body',
      className: 'vex-theme-default',
      overlayClassName: '',
      contentClassName: '',
      closeClassName: '',
      closeAllOnPopState: true
    };
  }

  constructor(element) {
    super(element);

    this.Vex = Vex;
    this.Vex.registerPlugin(VexDialog);

    this.handleResolutionChange();
  }

  // async importVex() {
  //   try {
  //     await import(/* webpackChunkName: "vex-css" */ 'vex-js/dist/css/vex.css');
  //     const VexDialog = await import(/* webpackChunkName: "vex-dialog" */ 'vex-dialog');
  //     this.Vex = await import(/* webpackChunkName: "vex-js" */ 'vex-js');
  //     this.Vex.registerPlugin(VexDialog.default);
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }

  handleResolutionChange() {
    const startWidth = window.innerWidth;
    Bean.on(window, 'resize.modal', (e) => {
      if (window.innerWidth !== startWidth) {
        const instances = this.Vex.getAll();
        if (!this.objectIsEmpty(instances)) this.closeModals();
      }
    });
  }

  async focus({ contentEl }) {
    const focusable = this.getFirstFocusable(contentEl);
    focusable.focus();
  }


  showModal(opts = {}) {
    const ctx = this;
    if (opts.selector) {
      if (!document.querySelector(opts.selector)) return console.warn('No element found with selector => ', opts.selector);
      opts.unsafeContent = document.querySelector(opts.selector).innerHTML;
    }
    return this.Vex.open({
      ...this.DEFAULT_OPTS,
      ...{
        afterOpen() {
          const vexInstance = this;
          // ctx.focus(vexInstance);
          ctx.EMIT(ctx.CUSTOM_MESSAGES.MODAL_EVENTS.afterOpen, { vexInstance });
        },
        afterClose() {
          const vexInstance = this;
          ctx.EMIT(ctx.CUSTOM_MESSAGES.MODAL_EVENTS.afterClose, { vexInstance });
        },
        beforeClose() {
          const vexInstance = this;
          ctx.EMIT(ctx.CUSTOM_MESSAGES.MODAL_EVENTS.beforeClose, { vexInstance });
          document.body.classList.remove('vex-open');
        }
      },
      ...opts,
      className: `vex-theme-default ${opts.className ? opts.className : ''}`
    });
  }

  closeModals() {
    return this.Vex.closeAll();
  }
}
